import loadable from '@loadable/component';

// 懒加载组件
const OrderManagement = loadable(() => import('./orderManagement/OrderManagement'));
const OrderDetailQuery = loadable(() => import('./orderDetailQuery/OrderDetailQuery'));
const OrderManagement2310 = loadable(() => import('./orderManagement2310/OrderManagement'));
const ImplantationOrderManagement = loadable(() => import('./implantationOrderManagement/ImplantationOrderManagement'));
const OrderWithUpstreamManagement = loadable(() => import('./orderWithUpstreamManagement/OrderManagement'));
const OrderDetailWithUpstreamQuery = loadable(() => import('./orderDetailWithUpstreamQuery/OrderDetailQuery'));
const ImplantationDeliveryDetailQuery = loadable(() => import('../supOperation/implantationDeliveryDetailQuery/ImplantationDeliveryDetailQuery'));

export const subRoutes = [
  {
    // 253001耗材订单查询响应
    path: '/OrderManagement',
    component: OrderManagement
  },
  {
    // 253006订单明细查询
    path: '/OrderDetailQuery',
    component: OrderDetailQuery
  },
  {
    // M253012【2310】供应商：订单查询响应
    path: '/OrderManagement2310',
    component: OrderManagement2310
  },
  {
    // 253013供应商：植入性订单响应
    path: '/ImplantationOrderManagement',
    component: ImplantationOrderManagement
  },
  {
    // M292001 上游：订单查询响应
    path: '/OrderWithUpstreamManagement',
    component: OrderWithUpstreamManagement
  },
  {
    // M292007 上游：订单明细查询
    path: '/OrderDetailWithUpstreamQuery',
    component: OrderDetailWithUpstreamQuery
  },
  {
    // M253014 供应商：植入性发货明细查询
    path: '/ImplantationDeliveryDetailQuery',
    component: ImplantationDeliveryDetailQuery
  }
];
